import React from 'react';
import iconLike from './images/icon-100-like@3x.svg';
import iconNotification from './images/icon-100-notification@3x.svg';
import iconCall from './images/icon-100-call-2@3x.svg';
import iconError from './images/icon-120-error@3x.svg';
import iconWhatsApp from './images/WhatsApp@3x.svg'

const ServiceMessages = (props) => {
    let iconImage = "";

    switch (props.iconType) {
        case "like":
            iconImage = iconLike;
            break;
        case "notification":
            iconImage = iconNotification;
            break;
        case "call":
            iconImage = iconCall;
            break;
        case "error":
            iconImage = iconError;
            break;
        case "whatsapp":
            iconImage = iconWhatsApp;
            break;
    }

    const showServiceCallWrapper = !["like", "notification" , "whatsapp"].includes(props.iconType);

    return (
        <div className='service-messages'>
            <div className='icon' style={{ backgroundImage: "url(" + iconImage + ")" }}></div>
            <div className='title'>{props.title}</div>
            <div className='subtitle'>{props.subTitle}</div>
            {showServiceCallWrapper && (
                <div className='service-call-wrapper'>
                    <div className='text'>אפשר גם לדבר איתנו ב-{window.Config.technicalSupportPhone} </div>
                </div>
            )}
        </div>

    );
};
export default ServiceMessages;
